import { render } from "./OrderSelector.vue?vue&type=template&id=ef466a1e"
import script from "./OrderSelector.vue?vue&type=script&lang=js"
export * from "./OrderSelector.vue?vue&type=script&lang=js"

import "./OrderSelector.vue?vue&type=style&index=0&id=ef466a1e&lang=css"

import exportComponent from "/codebuild/output/src383431102/src/serverlesspressoV3/frontends/vue-barista-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__